import { EmailAddress, PhoneNumber } from './contact-info.model';

export interface ExecutiveAssociate {
  executiveAssociateId: number | null;
  name: string;
  isPrimary: boolean;
  phoneNumbers: PhoneNumber[];
  emailAddresses: EmailAddress[];
}

export const isExecutiveAssociateSaved = (ea: ExecutiveAssociate) => {
  return ea.executiveAssociateId && ea.executiveAssociateId > 0;
};
